import { ALL_USER_ROLES } from '../data.types.js';
/** Provider roles allowed on ops / fleet / billing mutation routes. */
export const PROVIDER_OPS_ROLES = [
    ALL_USER_ROLES.provider_admin,
    ALL_USER_ROLES.provider_engineer,
];
/** Provider admin only — destructive or platform-wide configuration. */
export const PROVIDER_ADMIN_ROLES = [ALL_USER_ROLES.provider_admin];
/** Provider admin or deployment engineer — field deployment claim flows. */
export const PROVIDER_ADMIN_DEPLOYMENT_ROLES = [
    ALL_USER_ROLES.provider_admin,
    ALL_USER_ROLES.provider_deployment_engineer,
];
/** Provider roles allowed on deployment tooling routes. */
export const PROVIDER_DEPLOYMENT_ROLES = [
    ALL_USER_ROLES.provider_admin,
    ALL_USER_ROLES.provider_engineer,
    ALL_USER_ROLES.provider_deployment_engineer,
];
/** Provider roles allowed on read-only support API routes. */
export const PROVIDER_SUPPORT_READ_ROLES = [
    ALL_USER_ROLES.provider_admin,
    ALL_USER_ROLES.provider_support,
];
/** Provider roles allowed to list/read tenant records (full provider API). */
export const PROVIDER_TENANT_READ_ROLES = [
    ALL_USER_ROLES.provider_admin,
    ALL_USER_ROLES.provider_engineer,
    ALL_USER_ROLES.provider_deployment_engineer,
];
/**
 * Provider roles that bypass spatial-service SiteAccessGrant checks.
 * Internal provider staff (admin, engineer) may access any deployment site.
 * Contractors (provider_deployment_engineer) require an active grant per tenant/site.
 */
export const PROVIDER_DEPLOYMENT_SITE_GRANT_BYPASS_ROLES = [
    ALL_USER_ROLES.provider_admin,
    ALL_USER_ROLES.provider_engineer,
];
/** True when a provider role must hold an active SiteAccessGrant for the tenant/site. */
export function requiresDeploymentSiteGrant(role) {
    if (!role) {
        return true;
    }
    if (PROVIDER_DEPLOYMENT_SITE_GRANT_BYPASS_ROLES.includes(role)) {
        return false;
    }
    return PROVIDER_DEPLOYMENT_ROLES.includes(role);
}
//# sourceMappingURL=provider-access.js.map